import React from "react";
import T from "prop-types";
import { Field, FormSection, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import {
  form,
  Check,
  CheckGroup,
  Form as AppForm,
  FormInput,
  ShippingMethod
} from "MODULES/shared/components/Forms";
import { ADMIN, WAREHOUSE_BASIC } from "MODULES/users/constants";
import validate from "MODULES/Shipping/components/Dashboard/Create/validate";
import WeightAndDimensionsSection from "MODULES/parts/components/shared/FormSections/WeightAndDimensionsSection";

import { update } from "MODULES/OutgoingShipments/actions";

export function Form(props) {
  const { isManager, isBasicWarehouseUser, isIto } = props;

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row className="row-col-gutters-half">
          <Col md={5}>
            <Field
              name="read_only_part_number"
              label="Part #"
              component={FormInput}
              disabled
            />
          </Col>
          <Col md={3}>
            <Field
              name="read_only_serial_number"
              label="Serial #"
              component={FormInput}
              disabled
            />
          </Col>
        </Row>
        <hr className="hr-xs hr-dashed" />
        <WeightAndDimensionsSection />
        <hr className="hr-xs hr-dashed" />
        <FormSection name="shipping_method">
          <ShippingMethod
            disabled={!isManager && isBasicWarehouseUser}
            required={!isIto}
          />
        </FormSection>
        <Row className="row-col-gutters-half">
          <Col md={5}>
            <Field
              name="outgoing_awb_number"
              label="Outgoing AWB #"
              component={FormInput}
            />
          </Col>
          {props.dirty && (
            <Col md={7}>
              <CheckGroup justified>
                <Field
                  name="send_shipment_updated_email"
                  component={Check}
                  label="Send Shipment Update Email"
                />
              </CheckGroup>
            </Col>
          )}
        </Row>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  isManager: T.bool,
  isBasicWarehouseUser: T.bool,
  isIto: T.bool
};

const selector = formValueSelector("editShipment");

export default connect(
  state => ({
    discreet: selector(state, "discreet"),
    accountNumber: selector(state, "shipping_method.account_number"),
    carrier: selector(state, "shipping_method.carrier"),
    isManager:
      state.session.getIn(["user", "manager"]) ||
      state.session.getIn(["user", "role"]) === ADMIN,
    isBasicWarehouseUser:
      state.session.getIn(["user", "subrole"]) === WAREHOUSE_BASIC,
    shippingMethod: selector(state, "shipping_method.shipping_method"),
    getField: field => selector(state, field)
  }),
  (dispatch, props) => ({
    onSubmit: val => dispatch(update(props.shipment.id, val))
  })
)(
  form({
    form: "editShipment",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Panel/EditShipmentForm.jsx